import { render, staticRenderFns } from "./StepsSecondAddStudents.vue?vue&type=template&id=e2b0a03c&scoped=true"
import script from "./StepsSecondAddStudents.vue?vue&type=script&lang=js"
export * from "./StepsSecondAddStudents.vue?vue&type=script&lang=js"
import style0 from "./StepsSecondAddStudents.vue?vue&type=style&index=0&id=e2b0a03c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b0a03c",
  null
  
)

export default component.exports